import predicates from '../predicates'
import selectors from '../selectors'
import { EMAIL_TRAFFIC_SOURCE } from '../constants'

const email = {
  rule: predicates.and(
    predicates.searchParamIncludesOne('utm_medium', 'email'),
    predicates.searchParamsIncludeOne('utm_source')
  ),
  extractor: traffic => {
    const trafficSource = EMAIL_TRAFFIC_SOURCE
    const trafficId = selectors.searchParamValue(traffic, 'utm_source')

    return {
      trafficSource,
      trafficId,
    }
  },
}

export default email



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/pipelines/email.js